import { createSlice } from '@reduxjs/toolkit'

const roleArtdRateSlice = createSlice({
    name: 'roleArtdrate',
    initialState: {   
        staffRoleID: null,     
        flags: {        
            isFormEdited: false,
            isRoleRateParamsUpdated: false,
        },     
        
    },
    reducers: {               
        // Role Rate Param reducers
        updateFlag: (state, action) => {
            const { flag, value } = action.payload
            state.flags[flag] = value            
        },
        setStaffRole: (state, action) => {           
            state.staffRoleID = action.payload
        },
       
    },
    
})

export const {    
    updateFlag,
    setStaffRole,
} = roleArtdRateSlice.actions

export default roleArtdRateSlice.reducer

export const getFlags = (state) => state.roleArtdRate.flags
export const getStaffRoleID = (state) => state.roleArtdRate.staffRoleID